module.exports = __webpack_public_path__ + "media/loans/student-writing-f81c7635.webp";